<template>
    <div
        class="config-slot"
        :class="{ 'config-slot--empty': !product, 'config-slot--invalid': invalid }"
        role="button"
        tabindex="0"
        :title="reason"
        @click="$emit('select')"
        @keydown.enter="$emit('select')"
    >
        <template v-if="product">
            <span class="config-slot__name">{{ product.name }}</span>
            <span v-if="invalid" class="config-slot__alert" aria-hidden="true">
                <i class="i-andy-exclamation"></i>
            </span>
        </template>
        <template v-else>
            <i class="i-andy-close i-andy-m config-slot__empty-icon" aria-hidden="true"></i>
            <span class="config-slot__empty-label">{{ $t('phu_production.configuration.empty_slot') }}</span>
        </template>
    </div>
</template>

<script>
export default {
    name: 'ConfigSlot',
    props: {
        product: { type: Object, default: null },
        invalid: { type: Boolean, default: false },
        reason: { type: String, default: '' }
    }
}
</script>

<style lang="scss" scoped>
@import '~@/components/domain/phu-production/styles/tokens';

.config-slot {
    position: relative;
    @include display-flex();
    @include flex-direction(column);
    @include align-items(center);
    @include justify-content(center);
    min-height: 70px;
    padding: 4px 16px;
    border: 1px solid $neutro-s30;
    border-radius: $phu-radius-s;
    background-color: $phu-surface;
    text-align: center;
    cursor: pointer;

    &__name {
        max-width: 100%;
        word-break: normal;
        overflow-wrap: normal;
        font-family: $text-bold;
        font-size: 1rem;
        line-height: 20px;
        text-transform: uppercase;
        color: $phu-text;
    }

    &__reason {
        font-family: $text;
        font-size: 0.75rem;
        line-height: 16px;
        color: $phu-error;
    }

    &__alert {
        position: absolute;
        top: 2px;
        right: 20px;
        font-size: 0.75rem;
        i{
            color: $phu-error;
        }
    }

    &__clear {
        position: absolute;
        top: 2px;
        right: 2px;
        @include display-flex();
        @include align-items(center);
        @include justify-content(center);
        width: 16px;
        height: 16px;
        padding: 0;
        border: none;
        border-radius: 100%;
        color: $phu-text-muted;
        font-size: 0.75rem;
        cursor: pointer;
    }

    &__empty-icon {
        color: $neutro-s30;
    }

    &__empty-label {
        font-family: $text;
        font-size: 1rem;
        line-height: 20px;
        color: $neutro-s50;
    }

    &--empty {
        gap: 4px;
        border-style: dashed;
    }

    &--invalid {
        border: 2px solid $phu-error;
        background-color: $phu-error-soft;
    }
}
</style>
